export default __webpack_public_path__ + "static/media/software-4.1a81071e.png";